'use strict';

export default class BabyCareRoomAwards {
    constructor() {
        setTimeout(function() {
            if ($('.paragraph--type--comparison-table-element-').length == 2) {
                $('.paragraph--type--comparison-table-element-:first-child').parent().addClass('special-margin18');
                $('.paragraph--type--comparison-table-element-:first-child').first().parent().css("margin-left", "18%");
            }
        }, 100);
    }
}
